import Builder from '@/lib/api/dashboard/builder';
import Collections from '@/lib/api/dashboard/collections';
import Orders from '@/lib/api/dashboard/orders';
import CustomPages from '@/lib/api/dashboard/custom-pages';
import Products from '@/lib/api/dashboard/products';
import BlogPosts from '@/lib/api/dashboard/blog-posts';
import Blogs from '@/lib/api/dashboard/blogs';
import { AxiosInstance } from 'axios';
import Navigation from '@/lib/api/dashboard/navigation';
import FileService from '@/lib/api/dashboard/files-service';
import Locations from '@/lib/api/dashboard/location';
import Domain from '@/lib/api/dashboard/domain';
import Preferences from '@/lib/api/dashboard/preferences';
import GeneralSetting from '@/lib/api/dashboard/general-setting';
import ThirdPartyAnalytic from '@/lib/api/dashboard/third-party-analytic';
import Stocks from '@/lib/api/dashboard/stocks';
import Payment from '@/lib/api/dashboard/payment';
import Customer from '@/lib/api/dashboard/customer';
import Billing from '@/lib/api/dashboard/billing';
import AgeRestriction from '@/lib/api/dashboard/age-restriction';
import StoreInformation from '@/lib/api/dashboard/store-information';
import Shipping from '@/lib/api/dashboard/shipping';

class Dashboard {
  public builder: Builder;
  public collections: Collections;
  public orders: Orders;
  public customPages: CustomPages;
  public products: Products;
  public blogPosts: BlogPosts;
  public blogs: Blogs;
  public navigation: Navigation;
  public preferences: Preferences;
  public fileService: FileService;
  public locations: Locations;
  public domain: Domain;
  public generalSetting: GeneralSetting;
  public thirdPartyAnalytic: ThirdPartyAnalytic;
  public stocks: Stocks;
  public payment: Payment;
  public customer: Customer;
  public billing: Billing;
  public ageRestriction: AgeRestriction;
  public storeInformation: StoreInformation;
  public shipping: Shipping;

  constructor(client: AxiosInstance) {
    this.builder = new Builder(client);
    this.collections = new Collections(client);
    this.orders = new Orders(client);
    this.customPages = new CustomPages(client);
    this.products = new Products(client);
    this.blogPosts = new BlogPosts(client);
    this.blogs = new Blogs(client);
    this.navigation = new Navigation(client);
    this.preferences = new Preferences(client);
    this.fileService = new FileService(client);
    this.locations = new Locations(client);
    this.domain = new Domain(client);
    this.generalSetting = new GeneralSetting(client);
    this.thirdPartyAnalytic = new ThirdPartyAnalytic(client);
    this.stocks = new Stocks(client);
    this.payment = new Payment(client);
    this.customer = new Customer(client);
    this.billing = new Billing(client);
    this.ageRestriction = new AgeRestriction(client);
    this.storeInformation = new StoreInformation(client);
    this.shipping = new Shipping(client);
  }
}

export default Dashboard;
